document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.splide')) {
		if (document.querySelectorAll('.home__header-slide').length > 1) {

			// Headerslides
			new Splide('.splide', {
				type: "loop",
				arrows: false,
				autoplay: false,
				interval: document.querySelector('.splide').dataset.speed,
				pagination: true
			}).mount()
		}

	}
	if (document.querySelector('.referenzen__vorschauslider')) {

		new Splide('.referenzen__vorschauslider', {
			type: "loop",
			arrows: false,
			autoplay: false,
			pagination: true
		}).mount()

	}
	if (document.querySelector('.partner__certs')) {
		// Logoslides
		new Splide('.partner__certs', {
			type: "loop",
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 6,
			gap: '4rem',
			pagination: true,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '2rem'
				},
				967: {
					perPage: 4,
					gap: '2rem'
				},
				1240: {
					perPage: 5,
					gap: '4rem'
				},
			}
		}).mount()
	}
	if (document.querySelector('.mitarbeiter__slider')) {

		const mitarbeiterSliders = document.querySelectorAll('.mitarbeiter__slider')
		mitarbeiterSliders.forEach((slider, index) => {

			new Splide(slider, {
				type: 'loop',
				drag: 'free',
				focus: 'center',
				pagination: false,
				arrows: false,

				perPage: 5,
				autoScroll: {
					speed: index % 2 === 0 ? 0.25 : -0.25,
				},
			}).mount(window.splide.Extensions)
		})

	}
	if (document.querySelector('.referenzen__slider')) {

		const referenzenSliders = document.querySelectorAll('.referenzen__slider')
		referenzenSliders.forEach((slider, index) => {

			new Splide(slider, {
				type: 'loop',
				drag: 'free',
				focus: 'center',
				pagination: false,
				arrows: false,
				perPage: 6,
				autoScroll: {
					speed: index % 2 === 0 ? 0.25 : -0.25,
				},
				breakpoints: {
					640: {
						perPage: 4,
					},
					967: {
						perPage: 4,
					},
					1240: {
						perPage: 5,
					},
				}
			}).mount(window.splide.Extensions)
		})

	}
	if (document.querySelector('.referenzen__logoslider')) {

		const referenzenLogoSliders = document.querySelectorAll('.referenzen__logoslider')
		referenzenLogoSliders.forEach((slider, index) => {

			new Splide(slider, {
				// type: "loop",
				// autoWidth: true,
				arrows: false,
				// autoplay: true,
				// interval: 5000,
				perPage: 4,
				pagination: true,
				// gap: "4rem",
				breakpoints: {
					640: {
						perPage: 2,
					},
					967: {
						perPage: 3,
					},
					1240: {
						perPage: 4,
					},
				}
			}).mount()
		})

	}
	if (document.querySelector('.referenzen__imageslider')) {

		const referenzenImageSliders = document.querySelectorAll('.referenzen__imageslider')
		referenzenImageSliders.forEach((slider, index) => {

			new Splide(slider, {
				// type: "loop",
				// autoWidth: true,
				arrows: false,
				// autoplay: true,
				// interval: 5000,
				perPage: 3,
				pagination: true,
				gap: "2rem",
				breakpoints: {
					640: {
						perPage: 1,
					},
					967: {
						perPage: 2,
					},
					1240: {
						perPage: 3,
					},
				}
			}).mount()
		})

	}
})